import { Flex, Text } from "@gravity-ui/uikit";
import { useGravityDevice } from "src/hooks/useGravityDevice";

import { DeveloperCodingIcon } from "../Icons";
import { useMainBlockTranslate } from "./hooks/useMainBlockTranslate";
import css from "./MainBlock.module.scss";

export const MainBlock = () => {
  const { isMobile, isTablet } = useGravityDevice();

  const { title, subtitles } = useMainBlockTranslate();

  const subtitleTextVariant = isMobile
    ? "body-1"
    : isTablet
      ? "body-2"
      : "body-3";

  const titleTextVariant = isMobile
    ? "display-2"
    : isTablet
      ? "display-3"
      : "display-4";

  return (
    <Flex
      id="main"
      alignItems={"center"}
      direction={isTablet || isMobile ? "column" : "row"}
      justifyContent={"space-between"}
      width={"100%"}
      maxWidth={"1440px"}
      style={{
        paddingLeft: isMobile ? 30 : 50,
        paddingRight: isMobile ? 30 : 50,
      }}
    >
      <Flex direction={"column"}>
        <Text as="h1" variant={titleTextVariant} className={css.mainBlockText}>
          {title}
        </Text>
        <Flex direction={"column"} gap={4} style={{ maxWidth: 700 }}>
          {subtitles.map((subtitle, index) => {
            return (
              <Text
                variant={subtitleTextVariant}
                className={css.mainBlockText}
                key={`main_block.subtitle.${index}`}
              >
                {subtitle}
              </Text>
            );
          })}
        </Flex>
      </Flex>
      <DeveloperCodingIcon size={isMobile || isTablet ? "100%" : undefined} />
    </Flex>
  );
};
